import React from 'react';
import { BrowserRouter } from '@leagueplatform/routing';
import { ReactQueryDevtools } from 'react-query/devtools';
import {
  QueryClientProvider,
  LeagueProvider,
} from '@highmark-web/highmark-common';
import { AppRoutes } from 'common/routes';
import { config } from './init-config';

export function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider>
        <LeagueProvider config={config}>
          <AppRoutes />
          <ReactQueryDevtools />
        </LeagueProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}
